(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}(function () { 'use strict';

    class Audio {
        constructor() {
            // global class identifier
            this.class = {
                audioWrapper: '.audio_wrapper',
                audioText: '.js__audio-text',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * Two Click solution for YouTube Audio - Background-Image
         */
        audioPlaceholder() {
            if (document.querySelectorAll(this.class.audioWrapper).length > 0) {
                document.querySelectorAll(this.class.audioWrapper).forEach((wrapper) => {
                    wrapper.querySelector('button[type="button"]').addEventListener('click', (e) => {
                        const trigger = e.currentTarget.parentElement;
                        trigger.closest('.audio-module').querySelector(this.class.audioText).classList.add('d-none');
                        trigger.classList.add('d-none');
                        trigger.nextElementSibling.classList.add('d-block');
                        trigger.nextElementSibling.querySelector('iframe').setAttribute('src', trigger.dataset.source);
                    });
                });
            }
        }

        /**
         * Initialize Audio functions
         */
        init() {
            this.audioPlaceholder();
        }
    }

    new Audio();

    class Breadcrumbs {
        constructor() {
            // global class identifier
            this.class = {
                lorem: '.js-lorem',
                breadcrumb: '.js__breadcrumb',
                breadcrumbButton: '.js__breadcrumb-btn',
                breadcrumbCurrentItem: '.js__breadcrumb-current-item',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * Adding event handler
         */
        addBreadcrumbEventHandler() {
            const breadcrumbButton = document.querySelector(this.class.breadcrumbButton);

            if (breadcrumbButton) {
                // Register Eventhandler
                breadcrumbButton.addEventListener('click', (e) => this.handleBreadcrumbBehavior(e));
            }
        }

        /**
         * Toggle visibility of current breadcrumb item
         */
        handleBreadcrumbBehavior(e) {
            const breadcrumb = document.querySelector(this.class.breadcrumb);
            let firstElement = {};
            const lastElement = document.querySelector(this.class.breadcrumbCurrentItem);

            // Toggle button
            e.currentTarget.classList.toggle('d-none');

            // Add startpage eventlistener
            if (window.getComputedStyle(e.currentTarget).visibility !== 'hidden') {
                firstElement = breadcrumb.querySelector('.breadcrumb-item').firstChild;
                firstElement.addEventListener('click', (e) => this.showInitialState(e));
            }

            // Change flex direction
            if (breadcrumb && breadcrumb.classList.contains('collapsed')) {
                breadcrumb.classList.remove('collapsed');
            } else {
                breadcrumb.classList.add('collapsed');
            }

            // Toggle last breadcrumb item
            if (lastElement && lastElement.classList.contains('hidden')) {
                lastElement.classList.remove('hidden');
                lastElement.classList.remove('d-none');
            } else {
                lastElement.classList.add('hidden');
                lastElement.classList.add('d-none');
            }
        }

        /**
         * Reset breadcrumb to initial state
         */
        showInitialState(e) {
            e.preventDefault();

            const breadcrumb = document.querySelector(this.class.breadcrumb);
            const breadcrumbButton = document.querySelector(this.class.breadcrumbButton);

            // Call event
            breadcrumbButton.click();

            // Reset flex-direction to row
            if (breadcrumb && breadcrumb.classList.contains('collapsed')) {
                breadcrumb.classList.remove('collapsed');
            }

            // Enable startpage link default behavior
            e.currentTarget.removeEventListener('click', null);
        }

        /**
         * Initialize breadcrumb functions
         */
        init() {
            this.addBreadcrumbEventHandler();
        }
    }

    new Breadcrumbs();

    class Carousel {
        constructor() {
            this.class = {
                carousel: '.js-carousel',
                carouselInsideControlNext: '.carousel--inside .carousel-control-next.right',
                carouselInsideImageContainer: '.carousel--inside .carousel-backgroundimage-container',
                carouselInsideIndicators: '.carousel--inside .carousel-indicators',
                carouselItem: '.js-carousel-item',
                carouselControlNext: '.carousel-control-next',
                carouselControlPrev: '.carousel-control-prev',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * Add keyboard controls for more accessibility
         */
        addKeyboardControlls(carousel) {
            carousel.forEach((carouselItem) => {
                carouselItem.addEventListener('keyup', (event) => {
                    if (event.defaultPrevented) {
                        return; // Should do nothing if the default action has been cancelled
                    }

                    let handled = false;
                    const key = event.key || event.code || event.keyCode;

                    if (key === 'ArrowRight' || key === 39) {
                        document.querySelector(this.class.carouselControlNext).click();
                        handled = true;
                    } else if (key === 'ArrowLeft' || key === 37) {
                        document.querySelector(this.class.carouselControlPrev).click();

                        handled = true;
                    }

                    if (handled) {
                        // Suppress "double action" if event handled
                        event.preventDefault();
                    }
                });
            });
        }

        /**
         * function to iterate through all carousel items
         * and set all elements on same max height
         */
        setEqualHeights(carouselEl) {
            function setHeight(el, val) {
                if (typeof val === 'function') {
                    val = val();
                }
                if (typeof val === 'string') {
                    el.style.height = val;
                } else {
                    el.style.height = `${val}px`;
                }
            }

            let currentTallest = 0;
            const elements = [];
            let currentDiv;

            carouselEl.querySelectorAll(this.class.carouselItem).forEach((el, index) => {
                el.style.height = 'auto';
                // we need to activate all carousel items to get the height of the element
                el.classList.add('active');
                elements.push(el);
                currentTallest = (currentTallest < parseFloat(getComputedStyle(el, null).height.replace('px', '')))
                    ? (parseFloat(getComputedStyle(el, null).height.replace('px', '')))
                    : (currentTallest);
                for (currentDiv = 0; currentDiv < elements.length; currentDiv += 1) {
                    setHeight(elements[currentDiv], currentTallest);
                }
                if (index !== 0) {
                    // hide all items but first one
                    el.classList.remove('active');
                }
            });
        }

        setIndicatorsPositionCarouselInside() {
            const indicatorsContainer = document.querySelector(this.class.carouselInsideIndicators);
            const imageContainer = document.querySelector(this.class.carouselInsideImageContainer);
            if (!imageContainer) {
                return;
            }
            let imageContainerWidth = imageContainer.offsetWidth;
            const imageContainerRect = imageContainer.getBoundingClientRect();
            const indicatorTopPosition = imageContainerRect.height - indicatorsContainer.offsetHeight;

            function setPosition() {
                indicatorsContainer.style.setProperty('right', `calc(100vw - ${imageContainerWidth}px)`);
            }

            if (window.innerWidth > 1199 && window.innerWidth < 1400) {
                imageContainerWidth += 30;
                setPosition();
            } else if (window.innerWidth > 1399) {
                setPosition();
            } else {
                indicatorsContainer.style.removeProperty('right');
            }

            if (window.innerWidth < 576) {
                indicatorsContainer.style.setProperty('top', `${indicatorTopPosition}px`);
            } else {
                indicatorsContainer.style.setProperty('top', '');
            }
        }

        setArrowPositionCarouselInside() {
            const arrowContainerRight = document.querySelector(this.class.carouselInsideControlNext);
            const imageContainer = document.querySelector(this.class.carouselInsideImageContainer);
            if (!imageContainer) {
                return;
            }
            let imageContainerWidth = imageContainer.offsetWidth;

            function setPosition() {
                arrowContainerRight.style.setProperty('right', `calc(100vw - ${imageContainerWidth}px)`);
            }

            if (window.innerWidth > 1199 && window.innerWidth < 1400) {
                imageContainerWidth += 60;
                setPosition();
            } else if (window.innerWidth > 1399) {
                setPosition();
            } else {
                arrowContainerRight.style.removeProperty('right');
            }
        }

        init() {
            const carousel = document.querySelectorAll(this.class.carousel);
            if (carousel.length > 0) {
                this.addKeyboardControlls(carousel);

                // iterates through all carousel elements
                carousel.forEach((carouselEl) => {
                    window.addEventListener('load', () => {
                        this.setEqualHeights(carouselEl);
                    });

                    window.addEventListener('resize', () => {
                        setTimeout(() => {
                            this.setEqualHeights(carouselEl);
                            this.setArrowPositionCarouselInside();
                            this.setIndicatorsPositionCarouselInside();
                        });
                    });

                    // mobile devices rotation
                    window.addEventListener('orientationchange', () => {
                        setTimeout(() => {
                            this.setEqualHeights(carouselEl);
                        });
                    });
                    this.setArrowPositionCarouselInside();
                    this.setIndicatorsPositionCarouselInside();
                });
            }
        }
    }

    new Carousel();

    class Forms {
        constructor() {
            // global class identifier
            this.class = {
                needsValidation: '.needs-validation',
                offcanvasInput: '.js__offcanvas__solr-suggest',
                modalInput: '.js__modal__solr-suggest',
                newsletterSubscriptionFormField: 'input.subscription-email-prefill',
                newsletterSubscriptionFormFieldError: 'input.subscription-email-validation-error',
                searchItem: '.js__search-item',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * Handle form validations.
         * On any validation error, set "was-validated" class to form
         */
        handleFormValidations() {
            const forms = document.querySelectorAll(this.class.needsValidation);

            if (!forms.length > 0) {
                return;
            }

            // iterate through elements in each form and listen to "invalid" event
            forms.forEach((form) => {
                form.querySelectorAll('select, textarea, input').forEach((formelement) => {
                    formelement.addEventListener('invalid', (e) => {
                        if (!form.classList.contains('was-validated')) {
                            form.classList.add('was-validated');
                            form.classList.remove('needs-validation');
                            e.currentTarget.closest('.form-group').classList.remove('is-invalid');
                        }
                        e.currentTarget.closest('.form-group').classList.add('is-invalid');

                        // handle special case for radio button groups
                        if (e.target.type === 'radio') {
                            // find the closest parent with the button group class
                            const btnGroup = e.target.closest('.inputs-list');
                            if (btnGroup) {
                                // get the id of the btnGroup / .inputs-list element
                                const parentId = btnGroup.id;
                                const feedback = document.getElementById(`${parentId}-invalid-feedback-cb`);
                                feedback.setAttribute('aria-hidden', 'false');
                                feedback.removeAttribute('hidden');
                            }
                        }
                    });
                });

                // on change required input fields: check for validity, set aria labels
                form.querySelectorAll('[required]:not([type="radio"])').forEach((formelement) => {
                    formelement.addEventListener('change', (e) => {
                        const id = e.target.getAttribute('id');
                        this.setInvalidFeedbackAriaHidden(id);
                    });
                });

                // handle special case "a group of required radio buttons"
                form.querySelectorAll('input[type="radio"][required]').forEach((formelementRadio) => {
                    formelementRadio.addEventListener('change', (e) => {
                        const parent = e.target.closest('.inputs-list');
                        if (parent) {
                            // get the id of the parent / .inputs-list element
                            const parentId = parent.id;
                            const feedback = document.getElementById(`${parentId}-invalid-feedback-cb`);
                            feedback.setAttribute('aria-hidden', 'true');
                            feedback.setAttribute('hidden', 'hidden');
                        }
                    });
                });

                // handle special case "multi checkboxes required"
                const multibleCheckBoxRequiredContainers = document.querySelectorAll('.inputs-list-mcbr');
                multibleCheckBoxRequiredContainers.forEach((inputsListMcbr) => {
                    // collect checkboxes for "Array.from(checkboxes)"
                    const checkboxes = inputsListMcbr.querySelectorAll('input[type="checkbox"]');
                    checkboxes.forEach((checkbox) => {
                        checkbox.addEventListener('change', () => {
                            const isAnyChecked = Array.from(checkboxes)
                                .some((checkbox) => checkbox.checked);
                            const parentId = inputsListMcbr.id;
                            const feedback = document.getElementById(`${parentId}-invalid-feedback-cb`);
                            if (isAnyChecked) {
                                feedback.setAttribute('aria-hidden', 'true');
                                feedback.setAttribute('hidden', 'hidden');
                                feedback.style.display = 'none';
                            } else {
                                feedback.setAttribute('aria-hidden', 'false');
                                feedback.removeAttribute('hidden');
                                feedback.style.display = 'block';
                            }
                        });
                    });
                });

                // on click submit button ("form submit"): check for required fields validity, set aria
                form.querySelectorAll('button[type="submit"]').forEach((formelement) => {
                    formelement.addEventListener('click', (e) => {
                        // special case "radio buttons required"
                        form.querySelectorAll('[required]:not([type="radio"])').forEach((required) => {
                            const id = required.getAttribute('id');
                            this.setInvalidFeedbackAriaHidden(id);
                        });

                        // special case "multi checkboxes required"
                        multibleCheckBoxRequiredContainers.forEach((inputsListMcbr) => {
                            // collect checkboxes for "Array.from(checkboxes)"
                            const checkboxes = inputsListMcbr.querySelectorAll('input[type="checkbox"]');
                            const isAnyChecked = Array.from(checkboxes)
                                .some((checkbox) => checkbox.checked);
                            const parentId = inputsListMcbr.id;
                            const feedback = document.getElementById(`${parentId}-invalid-feedback-cb`);
                            if (!isAnyChecked) {
                                feedback.setAttribute('aria-hidden', 'false');
                                feedback.removeAttribute('hidden');
                                feedback.style.display = 'block';
                                // TODO: optimise this, because it ends the bootstrap validation
                                // (radiobutton mandatory e.g. not displayed)
                                document.getElementById(`${parentId}`)
                                    .getElementsByClassName('form-group')[0]
                                    .classList.add('is-invalid');
                                e.preventDefault();
                                e.stopPropagation();

                                // Try to find the first invalid input, select, or textarea
                                const firstInvalid = document.querySelector('input:invalid, select:invalid, textarea:invalid');

                                if (firstInvalid) {
                                    // Scroll to and focus the first invalid element
                                    firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    firstInvalid.focus();
                                } else {
                                    // If no invalid elements, scroll to the div with id "parent"
                                    const parentDiv = document.getElementById(`${parentId}`);
                                    if (parentDiv) {
                                        parentDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    }
                                }
                            }
                        });
                    });
                });
            });
        }

        /**
         * check bitv visibility of .invalid-feedback - set aria
         */
        // eslint-disable-next-line class-methods-use-this
        setInvalidFeedbackAriaHidden(id) {
            const inpObj = document.getElementById(id);
            const feedback = document.getElementById(`${id}-invalid-feedback`);

            if (inpObj.checkValidity() && feedback) {
                // input field
                inpObj.setAttribute('aria-invalid', 'false');
                const inpObjAriaFeedback = inpObj.getAttribute('aria-feedback') || '';
                this.removeAriaDescribedBy(inpObj, inpObjAriaFeedback);

                // feedback div
                feedback.setAttribute('aria-hidden', 'true');
                feedback.setAttribute('hidden', 'hidden');
            } else {
                // input field
                inpObj.setAttribute('aria-invalid', 'true');
                const inpObjAriaFeedback = inpObj.getAttribute('aria-feedback') || '';
                this.addAriaDescribedBy(inpObj, inpObjAriaFeedback);

                // feedback div
                feedback.setAttribute('aria-hidden', 'false');
                feedback.removeAttribute('hidden');
            }
        }

        /**
         * Function to add an ID to aria-describedby
         */
        // eslint-disable-next-line class-methods-use-this
        addAriaDescribedBy(element, newId) {
            const describedBy = element.getAttribute('aria-describedby') || '';
            const ids = describedBy.split(' ').filter(Boolean);
            if (!ids.includes(newId)) {
                ids.push(newId);
                element.setAttribute('aria-describedby', ids.join(' '));
            }
        }

        /**
         * Function to remove an ID from aria-describedby
         */
        // eslint-disable-next-line class-methods-use-this
        removeAriaDescribedBy(element, idToRemove) {
            const describedBy = element.getAttribute('aria-describedby') || '';
            let ids = describedBy.split(' ').filter(Boolean);
            ids = ids.filter((id) => id !== idToRemove);
            if (ids.length > 0) {
                element.setAttribute('aria-describedby', ids.join(' '));
            } else {
                element.removeAttribute('aria-describedby');
            }
        }

        /**
         * Set focus on search input
         */
        focusSearchInput() {
            const offcanvasInput = document.querySelector(this.class.offcanvasInput);
            const modalInput = document.querySelector(this.class.modalInput);
            const searchItem = document.querySelector(this.class.searchItem);

            // set autofocus offcanvas input only when search icon is clicked
            if (offcanvasInput && searchItem) {
                searchItem.addEventListener('click', () => {
                    document.querySelector('#offcanvas').addEventListener('shown.bs.offcanvas', function setFocus(e) {
                        offcanvasInput.focus();
                        // removes the event listener after focus
                        e.currentTarget.removeEventListener('shown.bs.offcanvas', setFocus);
                    });
                });
            }

            if (modalInput) {
                document.querySelector('#searchModal').addEventListener('shown.bs.modal', () => {
                    modalInput.focus();
                });
            }

            // removes focus when offcanvas is closed
            document.querySelector('#offcanvas').addEventListener('hidden.bs.offcanvas', () => {
                offcanvasInput.blur();
            });
        }

        /**
         * Prefill Email field from url in newsletter subscription form
         */
        prefillNewsletterSubscriptionForm() {
            const field = document.querySelector(this.class.newsletterSubscriptionFormField);
            const getParameter = 'email';

            if (field) {
                let getValue = '';
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                getValue = urlParams.get(getParameter);
                if (getValue) {
                    field.value = getValue;
                }
            }
        }

        /**
         * Display error msg in newsletter subscription form
         */
        errorNewsletterSubscriptionForm() {
            const field = document.querySelector(this.class.newsletterSubscriptionFormFieldError);

            if (field) {
                field.nextElementSibling.style.display = 'block';
            }
        }

        init() {
            this.handleFormValidations();
            this.focusSearchInput();
            this.prefillNewsletterSubscriptionForm();
            this.errorNewsletterSubscriptionForm();
        }
    }

    new Forms();

    class LeafletCustom {
        constructor() {
            // add global class identifier
            this.class = {
                rlpmaps: '.js-rlpmaps-map',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        // eslint-disable-next-line class-methods-use-this
        rlpMaps(url, layers, format, attribution, uid, mapObject, settingsMap1) {
            const settingsMap = settingsMap1;
            settingsMap.run = () => {
                settingsMap.zoom = mapObject.dataset.zoom;

                if (Number.isNaN(parseInt(settingsMap.zoom, 10))) {
                    settingsMap.zoom = 7;
                }

                settingsMap.autoFit = mapObject.dataset.autofit;
                settingsMap.focusFirst = mapObject.dataset.focusFirst;

                const records = document.getElementById(`rlpmaps__records__${uid}`);

                if (parseInt(settingsMap.focusFirst, 10) === 1) {
                    settingsMap.center = [
                        parseFloat(records.childNodes[0].getAttribute('data-lat')),
                        parseFloat(records.childNodes[0].getAttribute('data-lng')),
                    ];
                }

                settingsMap.map = L.map(mapObject.getAttribute('id')).setView(settingsMap.center, settingsMap.zoom);
                L.tileLayer
                    .wms(url, {
                        layers,
                        format,
                        transparent: true,
                        attribution,
                    })
                    .addTo(settingsMap.map);

                const rlpIcon = L.icon({
                    iconUrl: '/typo3conf/ext/rlp_maps/Resources/Public/Images/RLP_marker_Icon.png',
                    iconRetinaUrl: '/typo3conf/ext/rlp_maps/Resources/Public/Images/RLP_marker_Icon_2x.png',
                    shadowUrl: '/typo3conf/ext/rlp_maps/Resources/Public/Css/images/marker-shadow.png',
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    tooltipAnchor: [16, -28],
                    shadowSize: [41, 41],
                });
                for (let i = 0; i < records.childNodes.length; i += 1) {
                    const item = records.childNodes[i];
                    const dataId = item.getAttribute('data-id');

                    const marker = L.marker([item.getAttribute('data-lat'), item.getAttribute('data-lng')], { icon: rlpIcon })
                        .addTo(settingsMap.map)
                        .bindPopup(document.getElementById(`rlpmaps__record-${dataId}`).innerHTML);
                    settingsMap.markers.push(marker);
                }
                const group = new L.featureGroup(settingsMap.markers); // eslint-disable-line  new-cap
                if (parseInt(settingsMap.autoFit, 10) === 1) {
                    settingsMap.map.fitBounds(group.getBounds());
                }
            };

            settingsMap.openMarker = (markerId) => {
                settingsMap.markers[markerId].openPopup();
            };

            return settingsMap;
        }

        /**
         * initialize functions
         */
        init() {
            document.querySelectorAll(this.class.rlpmaps).forEach((map) => {
                let url = '';
                let attribution = '';
                const dataMapId = map.dataset.mapId;
                let layers = '';
                let format = '';
                const serviceUrl = 'https://maps.rlp.de/services/services-rlp.json';
                const dataUid = map.dataset.uid;
                // const map = this;
                const settingsMap = {
                    map: null,
                    markers: [],
                    center: [49.957, 7.152],
                    zoom: null,
                    focusFirst: 0,
                    autoFit: 0,
                };
                const self = this;
                const xhr = new XMLHttpRequest();
                xhr.open('POST', serviceUrl);
                xhr.addEventListener('load', () => {
                    if (xhr.status === 200) {
                        const data = JSON.parse(xhr.responseText);
                        if (data.error) ; else {
                            for (let i = 0; i < data.length; i += 1) {
                                if (data[i].id === dataMapId) {
                                    attribution = data[i].layerAttribution;
                                    url = data[i].url;
                                    layers = data[i].layers;
                                    format = data[i].format;
                                }
                            }

                            // eslint-disable-next-line max-len
                            const rlpMapsMapInstance = self.rlpMaps(url, layers, format, attribution, dataUid, map, settingsMap);
                            rlpMapsMapInstance.run();
                            document.addEventListener('click', (event) => {
                                if (!event.target.matches('.rlpmaps__markerlink')) {
                                    return;
                                }
                                event.preventDefault();
                                const element = event.target;
                                rlpMapsMapInstance.openMarker(parseInt(element.getAttribute('data-iteration-id'), 10));
                            }, false);
                        }
                    }
                });
                xhr.send();
            });
        }
    }

    new LeafletCustom();

    class SiteWideMessaging {
        constructor() {
            // add global class identifier
            this.class = {
                trigger: '.js__siteWideMessaging',
                delay: 1000 * 1.5,
                cookieName: 'siteWideMessaging',
                cookieValue: 1,
                closeButtonId: 'closeSiteWideMessaging',
                modalId: 'modalSiteWideMessaging',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * initialize functions
         */
        init() {
            this.siteWideMessaging();
        }

        /**
         * run side wide messaging
         */
        siteWideMessaging() {
            if (document.querySelectorAll(this.class.trigger).length > 0) {
                document.getElementById(this.class.closeButtonId).addEventListener('click', () => {
                    this.setCookie();
                });

                const cookie = this.getCookie(this.class.cookieName);
                if (!cookie) {
                    setTimeout(() => {
                        this.openModal();
                    }, this.class.delay);
                }
            }
        }

        openModal() {
            // trigger bootstrap modal event
            const modal = new bootstrap.Modal(document.getElementById(this.class.modalId), {});
            modal.show();
        }

        setCookie() {
            document.cookie = `${this.class.cookieName}=${this.class.cookieValue}`;
        }

        // eslint-disable-next-line class-methods-use-this
        getCookie(cname) {
            const name = `${cname}=`;
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i += 1) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        }

        // currently not in use
        deleteCookie() {
            document.cookie = `${this.class.cookieName}=;expires=Thu, 01 Jan 1970`;
        }
    }

    new SiteWideMessaging();

    class Video {
        constructor() {
            // global class identifier
            this.class = {
                videoWrapper: '.video_wrapper',
                carousel: '.carousel',
                videoText: '.js__video-text',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * Two Click solution for YouTube Video - Background-Image
         */
        videoPlaceholder() {
            const videoWrapper = document.querySelectorAll(this.class.videoWrapper);
            if (videoWrapper.length > 0) {
                videoWrapper.forEach((wrapper) => {
                    wrapper.querySelector('button[type="button"]').addEventListener('click', (e) => {
                        const trigger = e.currentTarget.parentElement;
                        trigger.closest('.video-module').querySelector(this.class.videoText).classList.add('d-none');
                        trigger.classList.add('d-none');
                        trigger.nextElementSibling.classList.add('d-block');
                        trigger.nextElementSibling.querySelector('iframe').setAttribute('src', `https://www.youtube-nocookie.com/embed/${trigger.dataset.source}?rel=0&controls=1&showinfo=1&autoplay=1`);
                    });
                });
            }
        }

        /**
         * Pause iframe videos on carousel slide
         */
        iframeVideoStopOnSlide() {
            const carousel = document.querySelectorAll(this.class.carousel);

            if (carousel.length > 0) {
                carousel.forEach((carouselItem) => {
                    carouselItem.addEventListener('slide.bs.carousel', () => {
                        document.querySelectorAll('.carousel-video').forEach((e) => {
                            if (e.currentTarget.closest('.carousel-item').classList.contains('active')) {
                                e.currentTarget.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                            }
                        });
                    });
                });
            }
        }

        init() {
            this.videoPlaceholder();
            this.iframeVideoStopOnSlide();
        }
    }

    new Video();

    class Mp4 {
        constructor() {
            // global class identifier
            this.class = {
                videoWrapper: '.mp4-video-module',
                videoBtn: '.mp4-video-module-btn',
                videoCopyright: '.mp4-video-module-copyright',
                videoItem: '.mp4-video-module-item',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * init mp4 video player
         */
        videoMp4Player() {
            const videoWrapper = document.querySelectorAll(this.class.videoWrapper);
            if (videoWrapper.length > 0) {
                videoWrapper.forEach((wrapper) => {
                    // trigger button
                    wrapper.querySelector('button[type="button"]').addEventListener('click', (e) => {
                        const trigger = e.currentTarget.parentElement;
                        trigger.closest(this.class.videoWrapper).querySelector(this.class.videoBtn).classList.add('d-none');
                        const isCopyrightExisting = document.getElementsByClassName('mp4-video-module-copyright');
                        if (isCopyrightExisting.length > 0) {
                            // eslint-disable-next-line max-len
                            const videoCopyright = trigger.closest(this.class.videoWrapper).querySelector(this.class.videoCopyright);
                            if (videoCopyright !== null) {
                                // eslint-disable-next-line max-len
                                videoCopyright.classList.add('d-none');
                            }
                        }
                        // eslint-disable-next-line max-len
                        const video = trigger.closest(this.class.videoWrapper).querySelector(this.class.videoItem);
                        video.play();
                    });

                    // trigger html video player
                    const currentVideo = document.querySelector(`#mp4-video-item-${wrapper.dataset.id}`);
                    currentVideo.addEventListener('play', () => {
                        document.querySelector(`#mp4-video-module-${wrapper.dataset.id} .mp4-video-module-btn`).classList.add('d-none');
                        const isCopyrightExisting = document.getElementsByClassName('mp4-video-module-copyright');
                        if (isCopyrightExisting.length > 0) {
                            // eslint-disable-next-line max-len
                            const videoCopyright = document.querySelector(`#mp4-video-module-${wrapper.dataset.id} .mp4-video-module-copyright`);
                            if (videoCopyright !== null) {
                                // eslint-disable-next-line max-len
                                videoCopyright.classList.add('d-none');
                            }
                        }
                    }, false);
                });
            }
        }

        init() {
            this.videoMp4Player();
        }
    }

    new Mp4();

    class LightGalleryCustom {
        constructor() {
            // add global class identifier
            this.class = {
                lightGallery: '.lightgallery',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * initialize functions
         */
        init() {
            const galleries = document.querySelectorAll(this.class.lightGallery);

            if (galleries.length > 0) {
                galleries.forEach((gallery) => {
                    const thumb = gallery.hasAttribute('data-enable-thumbs');
                    const imgDownload = gallery.hasAttribute('data-enable-download');
                    const countImg = gallery.querySelectorAll('.lightbox-item').length;
                    const enableDrag = countImg > 1;

                    const termsOfUseMarkup = document.querySelector('.js-lightgallery-termsofuse');

                    lightGallery(gallery, {
                        licenseKey: 'D6DCCE11-A9E44E57-A60D181A-DB8E015BD6DCCE11-A9E44E57-A60D181A-DB8E015B',
                        plugins: [lgThumbnail],
                        controls: true,
                        selector: 'a.lightbox-item',
                        thumbnail: thumb,
                        exThumbImage: 'data-external-thumb-image',
                        alignThumbnails: 'left',
                        download: imgDownload,
                        hideBarsDelay: 999999,
                        counter: false,
                        preload: 0,
                        closable: true,
                        enableDrag,
                        allowMediaOverlap: true,
                        toggleThumb: true,
                    });

                    gallery.addEventListener('lgBeforeOpen', () => {
                        const toolbar = document.querySelector('.lg-toolbar');
                        const toggleThumb = document.querySelector('.lg-toggle-thumb');
                        const components = document.querySelector('.lg-components');

                        // adds terms of use inside toolbar
                        toolbar.appendChild(termsOfUseMarkup);
                        toolbar.querySelector('.js-lightgallery-termsofuse').classList.remove('d-none');

                        // move toggle thumb button
                        components.appendChild(toggleThumb);
                    });

                    gallery.addEventListener('lgBeforeSlide', (event) => {
                        const { index } = event.detail;
                        const download = document.querySelector('.lg-download');
                        const lightboxItem = document.querySelectorAll('.lightbox-item')[index];
                        const filesize = document.querySelector('.lg-filesize');

                        // adds download label and size
                        if (!document.querySelector('.lg-download-wrapper')) {
                            const wrapper = document.createElement('div');
                            wrapper.classList.add('lg-download-wrapper');
                            download.parentNode.insertBefore(wrapper, download);
                            wrapper.appendChild(download);
                        }

                        // create new filesize markup if not exist, otherwise overwrite filesize
                        if (!filesize) {
                            download.insertAdjacentHTML('beforeend', `<div class="d-none d-sm-inline-block lb-dl-font">${lightboxItem.dataset.downloadlabel}<span class="lg-filesize ms-1">(${lightboxItem.dataset.filesize})</span></div>`);
                        } else {
                            filesize.innerHTML = `(${lightboxItem.dataset.filesize})`;
                        }
                    });
                });
            }
        }
    }

    new LightGalleryCustom();

    /*
    * here is an example class. You can use this example as a guide
     */

    class Accordion {
        constructor() {
            // add global class identifier
            this.class = {
                accordion: '.accordion',
                accordionItem: '.accordion-item',
                accordionButton: '.accordion-button',
                collapseContainer: '.accordion-collapse',
                buttonContainer: '.accordion-openclose-buttons',
                openButton: '.open-all',
                closeButton: '.close-all',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * initialize functions
         */
        init() {
            this.openCloseButtonFunction();
        }

        /**
         * On any click on the open/close-All buttons:
         * - adds or removes the class collapsed in the button of the headline container
         * - adds or removes the class show in the accordion-collapse container
         */
        openCloseButtonFunction() {
            const accordions = document.querySelectorAll(this.class.accordion);

            if (accordions.length > 0) {
                accordions.forEach((accordion) => {
                    if (accordion.querySelector(this.class.buttonContainer)) {
                        accordion.querySelector(this.class.openButton).addEventListener('click', () => {
                            accordion.querySelectorAll(this.class.accordionItem).forEach((item) => {
                                if (!item.querySelector(this.class.collapseContainer).classList.contains('show')) {
                                    item.querySelector(this.class.collapseContainer).classList.add('show');
                                }
                                if (item.querySelector(this.class.accordionButton).classList.contains('collapsed')) {
                                    item.querySelector(this.class.accordionButton).classList.remove('collapsed');
                                }
                            });
                        });

                        accordion.querySelector(this.class.closeButton).addEventListener('click', () => {
                            accordion.querySelectorAll(this.class.accordionItem).forEach((item) => {
                                if (item.querySelector(this.class.collapseContainer).classList.contains('show')) {
                                    item.querySelector(this.class.collapseContainer).classList.remove('show');
                                }
                                if (!item.querySelector(this.class.accordionButton).classList.contains('collapsed')) {
                                    item.querySelector(this.class.accordionButton).classList.add('collapsed');
                                }
                            });
                        });
                    }
                });
            }
        }
    }

    new Accordion();

    document.addEventListener('DOMContentLoaded', () => {
        const navLinks = document.querySelectorAll('.section-menu-listitem a');
        const sectionmenu = document.getElementsByClassName('section-menu-collapse')[0];
        const overlay = document.getElementsByClassName('dark-overlay')[0];
        const bootstrapcollapse = new bootstrap.Collapse(sectionmenu, { toggle: false });
        const mobileviewBreakpoint = 1199;
        const navigationContainer = sectionmenu.parentElement;
        const container = navigationContainer.parentElement;
        const main = document.querySelector('main');
        const toggleButton = document.querySelector('.section-menu-toggle');
        let isScrollmenu = true;

        navigationContainer.classList.add('section-menu-container');

        if (navLinks && bootstrapcollapse) {
            navLinks.forEach((link) => {
                link.addEventListener('click', () => {
                    if (window.innerWidth <= mobileviewBreakpoint) {
                        bootstrapcollapse.hide();
                    }
                });
            });
        }

        if (sectionmenu && overlay) {
            sectionmenu.addEventListener('hide.bs.collapse', (event) => {
                if (event.target.classList.contains('section-menu-collapse')) {
                    overlay.classList.remove('d-block');
                    overlay.classList.add('d-none');
                }
            });

            sectionmenu.addEventListener('show.bs.collapse', (event) => {
                if (event.currentTarget.classList.contains('section-menu-collapse')) {
                    overlay.classList.remove('d-none');
                    overlay.classList.add('d-block');
                }
            });
        }

        function getSections() {
            let section = null;

            if (navLinks) {
                section = Array.from(navLinks, (link) => {
                    const sectionId = link.getAttribute('href').substring(1);
                    return document.getElementById(sectionId.substring(sectionId.indexOf('#') + 1));
                });
            }
            return section;
        }

        function handleScroll() {
            const scrollPosition = window.scrollY;
            const sections = getSections();

            if (sections.every((value) => value === null)) {
                isScrollmenu = false;
            }

            sections.forEach((section, index) => {
                if (section) {
                    const sectionTop = section.offsetTop;
                    const sectionHeight = section.offsetHeight;
                    const navLink = navLinks[index];

                    if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
                        navLinks.forEach((link) => link.parentElement.classList.remove('current'));
                        navLink.parentElement.classList.add('current');
                        toggleButton.textContent = navLink.textContent;
                    }
                } else if (sectionmenu.querySelector('.active > a')) {
                    toggleButton.textContent = sectionmenu.querySelector('.active > a').innerText;
                }
            });
        }

        function handleSmallBreakpoints() {
            if (document.body.clientWidth <= mobileviewBreakpoint) {
                const sectionsList = main.querySelectorAll('section');
                let headerSection = null;

                sectionsList.forEach((section) => {
                    if (section.querySelector('.breadcrumb')) {
                        headerSection = section;
                    }
                });
                headerSection.parentNode.insertBefore(navigationContainer, headerSection.nextSibling);
            } else {
                container.insertBefore(navigationContainer, container.firstChild);
            }
        }

        handleSmallBreakpoints();
        handleScroll();
        if (isScrollmenu) {
            window.addEventListener('scroll', handleScroll);
        }
        window.addEventListener('resize', handleSmallBreakpoints);
    });

    document.addEventListener('DOMContentLoaded', () => {
        function setTouchedClass(event, flipcardItem) {
            if (flipcardItem) {
                if (!flipcardItem.classList.contains('flipcard-touched')) {
                    flipcardItem.classList.add('flipcard-touched', 'touch-active');
                } else {
                    flipcardItem.classList.remove('flipcard-touched');
                }
            }
        }

        // init tab navigation for accessibility (tab trough and trigger hover animation on enter)
        function initTabNavigation() {
            const flipcardItems = document.querySelectorAll('.flipcarditem');

            flipcardItems.forEach((flipcardItem) => {
                flipcardItem.addEventListener('focus', () => {
                    flipcardItem.addEventListener('keydown', (event) => {
                        // enter
                        if (event.which === 13) {
                            setTouchedClass(event, flipcardItem);
                        }
                    });
                });
            });
        }

        if ('ontouchstart' in window || navigator.maxTouchPoints) {
            document.addEventListener('touchstart', (event) => {
                setTouchedClass(event, event.target.closest('.flipcarditem'));
            }, { passive: true });
        } else {
            initTabNavigation();
        }
    });

    class ApplicationForm {
        constructor() {
            this.dot = '.';
            // add global class identifier
            this.class = {
                checkfield: '.checkinput',
                hidden: '.hidden',
                data: {},
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * initialize functions
         */
        init() {
            const checkProperties = document.querySelectorAll(this.class.checkfield);
            if (checkProperties.length > 0) {
                checkProperties.forEach((checkproperty) => {
                    checkproperty.checkData = checkproperty.dataset;
                    if (checkproperty.checkData.checkevent !== undefined) {
                        this.checkall(checkproperty);
                        checkproperty.addEventListener(checkproperty.checkData.checkevent, (evnt) => {
                            if (checkproperty.checkData.ckeckvalue !== undefined
                                && checkproperty.checkData.checkwhitch !== undefined
                            ) {
                                const selectorAll = this.dot + checkproperty.checkData.checkwhitch;
                                const targetProperties = document.querySelectorAll(selectorAll);
                                if (targetProperties !== undefined && targetProperties.length > 0) {
                                    targetProperties.forEach((targetProperty) => {
                                        this.checkall(checkproperty, targetProperty, evnt);
                                    });
                                }
                            }
                        });
                    }
                });
            }
        }

        checkall(checkproperty, property, evnt) {
            if (checkproperty !== undefined) {
                switch (checkproperty.checkData.checktype) {
                case 'hs':
                    this.checkHideFields(checkproperty, property, evnt);
                    break;
                case 'tl':
                    ApplicationForm.checkTextCount(checkproperty, property);
                    break;
                case 'co':
                    ApplicationForm.changeOptionValues(checkproperty, property, evnt);
                    break;
                case 'na':
                    ApplicationForm.checkNotAllowedValue(checkproperty, property, evnt);
                    break;
                default:
                }
            }
        }

        static checkNotAllowedValue(checkproperty, property, evnt) {
            if (property !== undefined && evnt !== undefined) {
                let propertyValue = '';

                switch (property.tagName) {
                case 'SELECT':
                    propertyValue = property.value;
                    break;
                default:
                }
                if (propertyValue !== undefined
                    && checkproperty.checkData.ckeckvalue !== undefined
                    && propertyValue === checkproperty.checkData.ckeckvalue
                ) {
                    if (checkproperty.checkData.checkalerttext !== undefined) {
                        alert(checkproperty.checkData.checkalerttext); // eslint-disable-line no-alert
                    }
                }
            }
        }

        static changeOptionValues(checkproperty, property, evnt) {
            if (property === undefined && evnt === undefined) {
                const selector = checkproperty.checkData.checkwhitch;
                const property = document.getElementsByClassName(selector)[0];
                const selectedValue = property.value;
                ApplicationForm.removeAllOptions(property);
                if (checkproperty.value === '') {
                    ApplicationForm.addOption(property, { '': checkproperty.checkData.checkstarttextnooption });
                } else {
                    const data = JSON.parse(checkproperty.checkData.checkdatajson);
                    ApplicationForm.addOption(property, { '': checkproperty.checkData.checkstarttextoption });
                    ApplicationForm.addOption(property, data[checkproperty.value], selectedValue);
                }
            } else if (evnt !== undefined) {
                if (checkproperty.checkData.checkdatajson !== undefined
                    && ApplicationForm.isJsonString(checkproperty.checkData.checkdatajson)
                ) {
                    const data = JSON.parse(checkproperty.checkData.checkdatajson);
                    ApplicationForm.removeAllOptions(property);
                    if (checkproperty.value === '') {
                        ApplicationForm.addOption(property, { '': checkproperty.checkData.checkstarttextnooption });
                    } else {
                        ApplicationForm.addOption(property, { '': checkproperty.checkData.checkstarttextoption });
                    }
                    ApplicationForm.addOption(property, data[evnt.target.value]);
                }
            }
        }

        static addOption(select, options, selectedValue) {
            if (options !== undefined) {
                const entries = Object.entries(options);
                const optionsCount = select.options.length;
                entries.forEach((element, key) => {
                    const selected = element[0] === selectedValue;
                    select[key + optionsCount] = new Option(element[1], element[0], false, selected);
                });
            }
        }

        static removeAllOptions(select) {
            const L = select.options.length - 1;
            for (let i = L; i >= 0; i -= 1) {
                select.remove(i);
            }
        }

        static isJsonString(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        }

        static checkTextCount(checkproperty, property) {
            const remainingTextLength = checkproperty.checkData.ckeckvalue - checkproperty.value.length;
            if (property === undefined) {
                const selector = checkproperty.checkData.checkwhitch;
                property = document.getElementsByClassName(selector);
            }
            property.innerHTML = remainingTextLength;
        }

        checkHideFields(checkproperty, property, evnt) {
            if (property === undefined && evnt === undefined) {
                const selectorAll = this.dot + checkproperty.checkData.checkwhitch;
                const hideFields = document.querySelectorAll(selectorAll);
                if (hideFields.length > 0) {
                    hideFields.forEach((field) => {
                        if (field.classList.contains('hidden')) {
                            ApplicationForm.hideShowField(checkproperty.value, checkproperty, field);
                        }
                    });
                }
            } else {
                ApplicationForm.hideShowField(evnt.target.value, checkproperty, property);
            }
        }

        static hideShowField(value, cmp, property) {
            if (cmp.checkData.ckeckvalue !== '') {
                if (value === cmp.checkData.ckeckvalue) {
                    property.style.setProperty('display', 'block', 'important');
                } else {
                    const resetFields = document.querySelectorAll(`.${cmp.checkData.checkwhitch} input`);
                    if (resetFields.length > 0) {
                        resetFields.forEach((field) => {
                            field.value = '';
                        });
                    }
                    property.style.display = 'none';
                }
            } else if (cmp.checkData.ckeckvalue === '') {
                if (value !== cmp.checkData.ckeckvalue) {
                    property.style.setProperty('display', 'block', 'important');
                } else {
                    const resetFields = document.querySelectorAll(`.${cmp.checkData.checkwhitch} input`);
                    if (resetFields.length > 0) {
                        resetFields.forEach((field) => {
                            field.value = '';
                        });
                    }
                    property.style.display = 'none';
                }
            }
        }
    }

    new ApplicationForm();

    function XDate(...args) {
        this.d = new Date();
        if (args.length) {
            this.from(args[0]);
        }
    }

    XDate.prototype.locale = 'de';

    XDate.prototype.setUnixtimestamp = function setUnixtimestamp(time) {
        this.d.setTime(time * 1000);
        return this;
    };

    XDate.prototype.setLocale = function setLocale(locale) {
        this.locale = locale;
        return this;
    };

    XDate.prototype.getUnixtimestamp = function getUnixtimestamp() {
        return Math.floor(this.d.getTime() / 1000);
    };

    XDate.prototype.descripe = function descripe() {
        return {
            day: this.date('d'),
            month: this.date('m'),
            year: parseInt(this.date('y'), 10),
            fullYear: parseInt(this.date('Y'), 10),
            '2diggets': {
                hour: this.date('H'),
                minutes: this.date('i'),
                seconds: this.date('s'),
            },
            hour: this.d.getHours(),
            minutes: this.d.getMinutes(),
            seconds: this.d.getSeconds(),
            dayname: this.date('l'),
            dayname_short: this.date('D'),
            monthname: this.date('F'),
            monthname_short: this.date('M'),
            dayofweek: this.date('N'),
            localtimezone: this.date('e'),
            differenceToGMT: this.date('O'),
            'am/pm': `${this.date('a')} / ${this.date('A')}`,
        };
    };

    XDate.prototype.toInt = function toInt(v) {
        return parseInt(v, 10);
    };

    XDate.prototype.datetest = function datetest() {
        /* eslint-disable no-console */
        console.log(this.date('d.m.y H:i:s \\U\\h\\r Y \\D:D \\l:l \\F:F \\M:M \\N:N \\e:e \\O:O \\a:a \\A:A \\W:W'));
        /* eslint-enable no-console */
    };

    /**
     * Beispiele
     * new XDate().date('d.m.y H:i:s \\U\\h\\r Y \\D:D \\l:l \\F:F
     * \\M:M \\N:N \\e:e \\O:O \\a:a \\A:A \\W:W');
     * new XDate().date('d',1);
     */
    XDate.prototype.date = function date(...args) {
        let r = '';
        let l = '';
        let a = '';
        let t = '';
        let dayNum = '';
        let yearStart = '';
        let d = '';
        let d1 = '';
        const value = args[0];

        for (let i = 0; i < value.length; i += 1) {
            const c = value.substring(i, i + 1);
            // let n;

            switch (c) {
            case '\\':
                r += value[i + 1];
                i += 1;
                // continue;
                break;
            case 'e':
                l = `${this.locale}-`;
                l += this.locale + ''.toUpperCase();
                r += this.d.toLocaleDateString(l, {
                    day: '2-digit', timeZoneName: 'long',
                }).slice(4);
                break;
            case 'a':
            case 'A':
                a = (this.d.getHours() < 12) ? 'am' : 'pm';
                r += (c === 'A') ? a.toUpperCase() : a;
                break;
            case 'O':
                r += this.d.getTimezoneOffset();
                break;
            case 'd':
                r += this.d.getDate().toString().padStart(2, '0');
                break;
            case 'D':
                r += new Intl.DateTimeFormat(this.locale, { weekday: 'short' }).format(this.d);
                break;
            case 'l':
                r += new Intl.DateTimeFormat(this.locale, { weekday: 'long' }).format(this.d);
                break;
            case 'F':
                r += new Intl.DateTimeFormat(this.locale, { month: 'long' }).format(this.d);
                break;
            case 'm':
                r += (this.d.getMonth() + 1).toString().padStart(2, '0');
                break;
            case 'M':
                r += new Intl.DateTimeFormat(this.locale, { month: 'short' }).format(this.d);
                break;
            case 'y':
                r += this.d.getFullYear().toString().substring(2, 4);
                break;
            case 'Y':
                r += this.d.getFullYear().toString();
                break;
            case 'h':
            case 'H':
                r += this.d.getHours().toString().padStart(2, '0');
                break;
            case 'i':
                r += this.d.getMinutes().toString().padStart(2, '0');
                break;
            case 's':
                r += this.d.getSeconds().toString().padStart(2, '0');
                break;
            case 'w':
                r += this.d.getDay();
                break;
            case 'W':
                t = new Date(Date.UTC(this.d.getFullYear(), this.d.getMonth(), this.d.getDate()));
                dayNum = t.getUTCDay() || 7;
                t.setUTCDate(t.getUTCDate() + 4 - dayNum);
                yearStart = new Date(Date.UTC(t.getUTCFullYear(), 0, 1));
                r += Math.ceil((((t - yearStart) / 86400000) + 1) / 7);
                break;
            case 'N': // ISO 8601 Montag=1,7=Sonntag=7
                d = this.d.getDay();
                if (d === 0) {
                    r += 7;
                    break;
                }
                r += d;
                break;
            case 't':
                d1 = new Date();
                d1.setTime(this.d.getTime());
                d1.setDate(1);
                d1.setMonth(d1.getMonth() + 1);
                d1.to('-1 day');
                r += d1.getDate();
                break;
            case 'G':
                r += this.d.getDate();
                break;
            default:
                r += c;
            }
        }
        return (args.length > 1) ? parseInt(r, 10) : r;
    };

    XDate.prototype.dateInt = function dateInt(...args) {
        return parseInt(this.date(args[0]), 10);
    };

    XDate.prototype.locales = {
        en: {
            shiftDays: {
                Sunday: 0,
                Monday: 1,
                Tuesday: 2,
                Wednesday: 3,
                Thursday: 4,
                Friday: 5,
                Saturday: 6,
            },
        },
        de: {
            shiftDays: {
                Monday: 1,
                Tuesday: 2,
                Wednesday: 3,
                Thursday: 4,
                Friday: 5,
                Saturday: 6,
                Sunday: 7,
            },
        },
    };

    XDate.prototype.toParsedDate = function toParsedDate(value) {
        let d = '';
        switch (value) {
        case 'today':
            d = new Date();
            this.d.setDate(d.getDate());
            this.d.setMonth(d.getMonth());
            this.d.setFullYear(d.getFullYear());
            break;
        default:
        }
        return this;
    };

    XDate.prototype.toMidnight = function toMidnight() {
        this.d.setHours(0);
        this.d.setMinutes(0);
        this.d.setSeconds(0);
    };

    XDate.prototype.intervall = function intervall(...args) {
        // let f;
        const r = [];
        let s;
        // const o;
        let value = args[0];
        let a = this.d.getTime();
        let l = this.convertDate(args[1], 'time') - a;
        const d = new Date(this.d.getTime());
        const f = (args.length > 2) ? args[2] : '';

        if (l < 0) {
            l *= -1;
        }
        l += a;

        value = value.replace(/^([+-])(.+)/, (m, p1, p2) => `${p1} ${p2}`); // replace(/^([\+-])(.+)/, (m, p1, p2) => `${p1} ${p2}`)
        // const p = value.split(' ');
        const [x, y, z] = value.split(' ');

        switch (x) {
        case '+':
        case '-':
            s = y;
            // const o = p[0];
            switch (z) {
            case 'minute':
                s *= 60;
                break;
            case 'hour':
                s *= 60 * 60;
                break;
            case 'day':
                s *= 86400;
                break;
            default:
            }
            break;
        default:
        }
        s *= 1000;
        while (a < l) {
            switch (f) {
            case 'format':
                r.push(d.date(args[3]));
                break;
            case 'unixtime':
                r.push(Math.floor(a / 1000));
                break;
            default:
                r.push(a);
            }
            a += s;
            d.setTime(a);
        }
    };

    XDate.prototype.getLocale = function getLocale() {
        return this.locale;
    };

    XDate.prototype.compare = function compare(c, val) {
        const t = this.getUnixtimestamp();
        // val = (typeof val === 'object' && val.hasOwnProperty('getUnixtimestamp'))
        val = (typeof val === 'object' && Object.prototype.hasOwnProperty.call(val, 'getUnixtimestamp'))
            ? val.getUnixtimestamp() : new XDate().from(val).getUnixtimestamp();
        switch (c) {
        case '<':
            return t < val;
        case '>':
            return t > val;
        case '<=':
            return t <= val;
        case '>=':
            return t >= val;
        case '==':
            return t === val;
        default:
        }
        return false;
    };

    XDate.prototype.from = function from(v) {
        this.d = (this.convertDate(v)).d;

        return this;
    };

    XDate.prototype.format = function format(value) {
        const p = value.split(' ');
        let y = '';
        let a = '';

        switch (p[0]) {
        case 'ymd':
        case 'Ymd':
            y = p[0].substring(0, 1);
            switch (this.locale) {
            case 'en':
                return this.date(`${y}-m-d`);
            default:
                return this.date(`d.m.${y}`);
            }
        case 'Hi':
            switch (this.locale) {
            case 'en':
                a = p[1] ? p[1] : 'a';
                return this.date(`h:i ${a}`);
            default:
                return this.date('H:i');
            }
        default:
        }
        return false;
    };

    XDate.prototype.to = function to(...args) {
        let t = 0;
        let m;
        let value = args[0];
        value = value.replace(/^([+-])(.+)/, (m, p1, p2) => `${p1} ${p2}`); // replace(/^([\+-])(.+)/, (m, p1, p2) => `${p1} ${p2}`)
        const p = value.split(' ');
        let day = '';
        let pm = '';
        let cnt = 0;
        let d = '';

        switch (p[0]) {
        case '+':
        case '-':
            switch (p[2]) {
            case 'day':
            case 'week':
                m = (p[2] === 'week') ? 7 : 1;
                t = 86400 * 1000;
                if (p[0] === '+') {
                    this.d.setTime(this.d.getTime() + (p[1] * t * m));
                    return (p.length > 3) ? this.to(p.splice(3).join(' ')) : this;
                }
                this.d.setTime(this.d.getTime() - (p[1] * t));
                return (p.length > 3) ? this.to(p.splice(3).join(' ')) : this;
            case 'hour':
                m = this.d.getHours();
                if (p[0] === '+') {
                    for (let i = 0; i < p[1]; i += 1) {
                        m += 1;
                        if (m === 24) {
                            m = 0;
                            this.to('+1 day');
                        }
                        this.d.setHours(m);
                    }
                } else {
                    for (let i = p[1]; i > 0; i -= 1) {
                        m -= 1;
                        if (m < 0) {
                            m = 23;
                            this.to('-1 day');
                        }
                        this.d.setHours(m);
                    }
                }
                break;
            case 'minute':
                m = this.d.getMinutes();
                if (p[0] === '+') {
                    for (let i = 0; i < p[1]; i += 1) {
                        m += 1;
                        if (m === 60) {
                            m = 0;
                            this.to('+1 hour');
                        }
                        this.d.setMinutes(m);
                    }
                } else {
                    for (let i = p[1]; i > 0; i -= 1) {
                        m -= 1;
                        if (m < 0) {
                            m = 59;
                            this.to('-1 hour');
                        }
                        this.d.setMinutes(m);
                    }
                }
                break;
            case 'second':
                m = this.d.getSeconds();
                if (p[0] === '+') {
                    for (let i = 0; i < p[1]; i += 1) {
                        m += 1;
                        if (m === 60) {
                            m = 0;
                            this.to('+1 minute');
                        }
                        this.d.setSeconds(m);
                    }
                } else {
                    for (let i = p[1]; i > 0; i -= 1) {
                        m -= 1;
                        if (m < 0) {
                            m = 59;
                            this.to('-1 minute');
                        }
                        this.d.setSeconds(m);
                    }
                }
                break;
            case 'month':
                m = this.d.getMonth();
                if (p[0] === '+') {
                    for (let i = 0; i < p[1]; i += 1) {
                        m += 1;
                        if (m === 12) {
                            m = 0;
                            this.to('+1 year');
                        }
                        this.d.setMonth(m);
                    }
                } else {
                    for (let i = p[1]; i > 0; i -= 1) {
                        m -= 1;
                        if (m < 0) {
                            m = 11;
                            this.to('-1 year');
                        }
                        this.d.setMonth(m);
                    }
                }
                break;
            case 'year':
                if (p[0] === '+') {
                    this.d.setFullYear(this.d.getFullYear() + parseInt(p[1], 10), 10);
                } else {
                    this.d.setFullYear(this.d.getFullYear() - parseInt(p[1], 10), 10);
                }
                break;
            default:
            }
            return (p.length > 3) ? this.to(p.splice(3).join(' ')) : this;
        case 'next':
        case 'last':
            if (p.length >= 4 && p[0] + p[1] + p[2] + p[3] === 'lastdayofmonth') {
                this.d.setDate(1);
                this.to('+1 month').to('-1 day');
                return (p.length > 4) ? this.to(p.splice(4).join(' ')) : this;
            }
            switch (p[1]) {
            default:
                day = this.locales.de.shiftDays[p[1]] ? this.locales.de.shiftDays[p[1]] : null;
                if (!day) {
                    /* eslint-disable no-console */
                    console.error(`${p[1]} nicht definiert`);
                    /* eslint-enable no-console */
                    return this;
                }
                pm = (p[0] === 'next') ? '+' : '-';
                cnt = 0;
                while (this.dateInt('N') !== this.locales.de.shiftDays[p[1]]) {
                    this.to(`${pm}1 day`);
                    cnt += 1;
                    if (cnt > 10) {
                        break;
                    }
                }
                return (p.length > 2) ? this.to(p.splice(2).join(' ')) : this;
            }
        case 'first':
            if (p.length >= 4 && p[1] + p[2] + p[3] === 'dayofmonth') {
                this.d.setDate(1);
                return (p.length > 4) ? this.to(p.splice(4).join(' ')) : this;
            }
            break;
        case 'second':
            this.d.setSeconds(p[1]);
            return (p.length > 2) ? this.to(p.splice(2).join(' ')) : this;
        case 'minute':
            this.d.setMinutes(p[1]);
            return (p.length > 2) ? this.to(p.splice(2).join(' ')) : this;
        case 'hour':
            this.d.setHours(p[1]);
            return (p.length > 2) ? this.to(p.splice(2).join(' ')) : this;
        case 'midnight':
            this.toMidnight();
            return (p.length > 1) ? this.to(p.splice(1).join(' ')) : this;
        case 'today':
            d = new Date();
            this.d.setDate(d.getDate());
            this.d.setMonth(d.getMonth());
            this.d.setFullYear(d.getFullYear());
            return (p.length > 1) ? this.to(p.splice(1).join(' ')) : this;
        default:
        }

        if (p[1] === 'this' && p[2] === 'week') {
            const day = this.locales.de.shiftDays[p[0]];
            if (!day) {
                /* eslint-disable no-console */
                console.error(`${p[0]} nicht definiert`);
                /* eslint-enable no-console */
                return this;
            }
            if (this.dateInt('N') !== day) {
                const pm = (this.date('N', 1) > day) ? '-' : '+';
                while (this.date('N', 1) !== day) {
                    this.to(`${pm}1 day`);
                }
            }
            return (p.length > 3) ? this.to(p.splice(3).join(' ')) : this;
        }
        this.d = this.from(this.convertDate(Date.parse(value))).d;
        return this;
    };

    XDate.prototype.copy = function copy() {
        const copy = new XDate(this.d.getTime());
        copy.setLocale(this.locale);
        return copy;
    };

    XDate.prototype.lastMonday = function lastMonday() {
        const prevMonday = new Date();
        return prevMonday.setDate((prevMonday.getDate() - (prevMonday.getDay() + 6)) % 7);
    };

    XDate.prototype.convertDate = function convertDate(v, ...args) {
        let x;
        let to = (args.length > 1) ? args[1] : 'XDate';
        const [b] = (args.length > 1) ? args[2] : '';

        switch (typeof v) {
        case 'object':
            if (v.getUnixtimestamp) {
                x = v;
            } else if (v.setTime) {
                x = new XDate().from(v.getTime());
            }
            break;
        case 'number':
            x = new XDate();
            if (v.toString().length < 11) {
                x.d.setTime(parseInt(v, 10) * 1000);
                // x.d.setTime(parseInt(v) * 1000+(x.d.getTimezoneOffset()*60*1000));
            } else {
                x.d.setTime(parseInt(v, 10));
            }
            break;
        case 'string':
            x = (args.length > 2) ? args[1] : new XDate().to(v);
            switch (args.length) {
            case 1:
            case 2:
                to = 'XDate';
                break;
            case 3:
                to = b; // arguments[2];
                break;
            default:
            }
            break;
        default:
        }
        let t;
        switch (to) {
        case 'time':
            t = x.d.getTime();
            break;
        case 'unixtime':
            t = x.getUnixtimestamp();
            break;
        case 'format':
            t = x.date(args[2]);
            break;
        default:
            t = x;
        }
        return t;
    };

    class Kalender {
        constructor(...args) {
            this.cfg = {
                id: 'kalender',
                locale: 'de',
                selected: null,
                header: {
                    days: 'D',
                    show: true,
                },
                events: {
                    onDaySelect: null,
                    onMonthChange: null,
                    onPrevMonth: null,
                    onNextMonth: null,
                    onLimitLeft: null,
                    onLimitRight: null,
                },
                display: {
                    showWeekdays: true,
                },
                data: {
                    monthPossibilities: {},
                },
                navigation: {
                    limitLeft: null,
                    limitRight: null,
                    topNav: {
                        show: true,
                        titleMonth: 'F Y',
                        titleMonthThisYear: 'F',
                    },
                },
            };
            // this.date = arguments.length && arguments[0].hasOwnProperty('date')
            // ? new XDate().from(arguments[0].date) : new XDate();
            this.date = args.length && Object.prototype.hasOwnProperty.call(args[0], 'date')
                ? new XDate().from(args[0].date) : new XDate();
            // this.root = null;
            this.cfg = this.deepMergeObject(this.cfg, args[0]);
            this.date.setLocale(this.cfg.locale);
            // this.init(this.cfg);
            // add global class identifier
            this.class = {
                lorem: '.js-lorem',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init(this.cfg);
            }
        }

        /**
         * initialize functions
         */
        init() {
            this.initializedEvent = new Event('initialized', { bubbles: true, cancelable: false });
            this.updatedEvent = new Event('updated', { bubbles: true, cancelable: false });
            this.pleaseReloadEvent = new Event('pleaseReload', { bubbles: true, cancelable: false });
            this.selectEvent = new Event('select', { bubbles: true, cancelable: false });

            this.render();
            this.bindEvents();
        }

        mergeCfg(cfg) {
            let mergedObj = {};
            mergedObj = this.deepMergeObject(this.cfg, cfg);
            return mergedObj;
        }

        deepMergeObject(target, source) {
            // const output = Object.assign({}, target);
            const output = ({ ...target });
            if ((target && typeof target === 'object' && !Array.isArray(target))
                && (source && typeof source === 'object' && !Array.isArray(source))
            ) {
                Object.keys(source).forEach((key) => {
                    if (typeof source[key] === 'object' && !Array.isArray(source[key])) {
                        if (!(key in target)) {
                            Object.assign(output, { [key]: source[key] });
                        } else if (target[key] !== null) {
                            output[key] = this.deepMergeObject(target[key], source[key]);
                        } else {
                            output[key] = source[key];
                        }
                    } else {
                        Object.assign(output, { [key]: source[key] });
                    }
                });
            }
            return output;
        }

        bindEvents() {
            const r = this.root;
            const that = this;
            const prevMonth = r.querySelector("button[class^='prev-month']");
            const nextMonth = r.querySelector("button[class^='next-month']");
            const currentMonth = r.querySelector("div[class^='current-month']");

            prevMonth.addEventListener('click', (evnt) => {
                evnt.preventDefault();
                this.to('-1 month');
            });

            nextMonth.addEventListener('click', (evnt) => {
                evnt.preventDefault();
                this.to('+1 month');
            });

            currentMonth.addEventListener('click', (evnt) => {
                evnt.preventDefault();
                that.root.dispatchEvent(that.pleaseReloadEvent); // .bind(that);
            });
        }

        render() {
            const elemDiv = document.createElement('div');
            const elemBut = document.createElement('button');
            const rootDiv = elemDiv.cloneNode();

            rootDiv.classList.add('lfs-termin-kalender');
            rootDiv.classList.add('initialization');
            rootDiv.setAttribute('id', this.cfg.id);

            const r = rootDiv;
            this.root = rootDiv;
            let xd = this.date.copy();
            // const today = new XDate().to('midnight').getUnixtimestamp();
            let firstOfMonth = this.date.copy().to('first day of month');
            // const lastOfMonth = this.date.copy().to('last day of month').getUnixtimestamp();
            const act = firstOfMonth.copy().to('last Monday');
            // let d;
            // let d2;
            firstOfMonth = firstOfMonth.getUnixtimestamp();

            let otherDiv = elemDiv.cloneNode();

            otherDiv.classList.add('month');
            const d = otherDiv;
            r.appendChild(d);

            let but = elemBut.cloneNode();

            but.classList.add('prev-month', 'rlp-i', 'icon-arrow_left');
            d.appendChild(but);

            otherDiv = elemDiv.cloneNode();
            otherDiv.classList.add('current-month');
            otherDiv.innerHTML = '';
            d.appendChild(otherDiv);

            but = elemBut.cloneNode();
            but.classList.add('next-month', 'rlp-i', 'icon-arrow_right');
            d.appendChild(but);

            otherDiv = elemDiv.cloneNode();
            otherDiv.classList.add('body');
            const body = otherDiv;
            r.appendChild(body);

            if (this.cfg.display.showWeekdays) {
                otherDiv = elemDiv.cloneNode();
                otherDiv.classList.add('weekwrap');
                const w = otherDiv;
                body.appendChild(w);

                otherDiv = elemDiv.cloneNode();
                otherDiv.classList.add('kw');
                otherDiv.innerText = 'KW';
                w.appendChild(otherDiv);

                otherDiv = elemDiv.cloneNode();
                otherDiv.classList.add('weeks');
                const weeks = otherDiv;
                w.appendChild(weeks);

                otherDiv = elemDiv.cloneNode();
                for (let i = 0; i < 6; i += 1) {
                    otherDiv = elemDiv.cloneNode();
                    otherDiv.classList.add('day');
                    otherDiv.innerHTML = i;
                    weeks.appendChild(otherDiv);
                }
            }

            otherDiv = elemDiv.cloneNode();
            otherDiv.classList.add('calendar-wrap');
            const c = otherDiv;
            body.appendChild(c);

            otherDiv = elemDiv.cloneNode();
            otherDiv.classList.add('weekdays');
            const wd = otherDiv;
            c.appendChild(wd);

            const wdr = elemDiv.cloneNode();
            wdr.classList.add('weekdays-wrap');
            // d = otherDiv;
            wd.appendChild(wdr);

            xd.to('next Monday');
            for (let i = 0; i < 7; i += 1) {
                otherDiv = elemDiv.cloneNode();
                otherDiv.innerHTML = xd.date('D');
                wdr.append(otherDiv);
                xd.to('+1 day');
            }

            otherDiv = elemDiv.cloneNode();
            otherDiv.classList.add('days');
            const days = otherDiv;
            c.appendChild(days);

            otherDiv = elemDiv.cloneNode();
            otherDiv.classList.add('days-wrap');
            const dayswr = otherDiv;
            days.appendChild(dayswr);

            xd = this.date.copy();
            xd.to('last Monday');

            // let css, uts, e, s;
            for (let i = 0; i < 42; i += 1) {
                but = elemBut.cloneNode();
                dayswr.appendChild(but);
                act.to('+1 day');
            }
            this.cfg.parent.appendChild(r);

            this.update();
            r.classList.remove('initialization');
            r.classList.add('initialized');
            r.dispatchEvent(this.initializedEvent);
        }

        getRoot() {
            return this.root;
        }

        to(value) {
            let newDate;
            newDate = this.date.copy().to(value);
            if (typeof value === 'string') {
                newDate = this.date.copy().to(value);
            }
            if (this.cfg.events.onMonthChange) {
                this.cfg.events.onMonthChange(new CustomEvent('onMonthChange'), newDate.getUnixtimestamp(), newDate);
            }
        }

        set(...args) {
            const [x, y] = args;
            let properties;

            if (args.length === 2) {
                // properties[arguments[0]] = arguments[1];
                properties[x] = y;
            } else {
                properties = x;
            }
            this.cfg = this.deepMergeObject(properties);

            return this;
        }

        getSelectedDays() {
            return this.root.querySelector("button[class^='day selected']");
        }

        getDate() {
            return this.date;
        }

        selectDay(...args) {
            let d;
            const [x] = args;

            if (this.root.querySelector("button[class*='selected']") !== null) {
                this.root.querySelector("button[class*='selected']").classList.remove('selected');
            }
            if (typeof x === 'object') {
                d = x;
                x.classList.add('selected');
            }
            if (typeof x === 'string') {
                d = this.root.querySelector(`data-t="${x}"`);
                d.classList.add('selected');
            }
            this.root.dispatchEvent(new CustomEvent('select', [d.dataset.t, parseInt(d.innerHTML, 10)]));

            if (this.cfg.events.onDaySelect) {
                this.cfg.events.onDaySelect(new CustomEvent('selected'), d.dataset.t, parseInt(d.innerHTML, 10));
            }

            return this.date;
        }

        updateNavigation() {
            if (this.cfg.navigation.limitLeft) {
                const prevMonth = this.root.querySelector("button[class^='prev-month']");

                if (this.date.compare('<=', this.cfg.navigation.limitLeft)) {
                    prevMonth.classList.add('hidden');
                } else {
                    prevMonth.classList.remove('hidden');
                }
            }
            if (this.cfg.navigation.limitRight) {
                const nextMonth = this.root.querySelector("button[class^='next-month']");

                if (this.date.compare('>=', this.cfg.navigation.limitRight)) {
                    nextMonth.classList.add('hidden');
                } else {
                    nextMonth.classList.remove('hidden');
                }
            }
        }

        update(...args) {
            const that = this;
            this.date.setLocale(this.cfg.locale);
            if (args.length) {
                this.cfg = this.deepMergeObject(args[0]);
                this.date.from(args[0].date).to('first day of month');
            }
            this.root.querySelector("div[class='current-month']").innerHTML = this.date.date(this.cfg.navigation.topNav.titleMonth);

            if (this.cfg.display.showWeekdays) {
                const date = this.date.copy();
                const weeks = this.root.querySelector("div[class='weeks']");

                Array.from(weeks.children).forEach((d) => { // each(function (i, d) {
                    d.innerHTML = date.date('W');
                    date.to('+1 week');
                });
            }

            const today = new XDate().to('midnight').getUnixtimestamp();
            let firstOfMonth = this.date.copy().to('first day of month');
            const lastOfMonth = this.date.copy().to('last day of month').getUnixtimestamp();
            const act = firstOfMonth.copy().to('last Monday');
            let css;
            let uts;
            firstOfMonth = firstOfMonth.getUnixtimestamp();

            const daysWrap = this.root.querySelector("div[class='days-wrap']");

            Array.from(daysWrap.children).forEach((button) => {
                button.setAttribute('disabled', true);
                css = ['day'];
                uts = act.getUnixtimestamp();
                if (uts === that.cfg.selected) {
                    css.push('selected');
                }
                if (uts < firstOfMonth) {
                    css.push('before');
                    css.push('month-before');
                } else if (uts > lastOfMonth) {
                    css.push('after');
                } else if (uts < today) {
                    css.push('before');
                    css.push('before-today');
                }
                // if (that.cfg.data.monthPossibilities.hasOwnProperty(uts)
                if (Object.prototype.hasOwnProperty.call(that.cfg.data.monthPossibilities, uts)
                    && that.cfg.data.monthPossibilities[uts]
                ) {
                    css.push('possible');
                    button.removeAttribute('disabled');
                    button.addEventListener('click', (evnt) => {
                        evnt.preventDefault();
                        const d = evnt.target;
                        that.selectDay(d);
                    }); // .bind(e));
                }
                button.innerHTML = (act.date('d'));
                button.setAttribute('class', css.join(' '));
                button.setAttribute('data-t', uts);

                act.to('+1 day');
            });

            this.updateNavigation();
            this.root.classList.remove('initialized');
            this.root.dispatchEvent(this.updatedEvent);
        }
    }

    class Buchung {
        constructor() {
            this.host = window.location.hostname;
            this.xhr = {
                'finanzamt-koblenz.lfstermin': {
                    url: window.lfs_termin_request_url,
                    auth: false,
                },
            };
            this.dom = {};
            this.ajaxRequestSuffix = '.lfstermin.json';
            // add global class identifier
            this.class = {
                akenzoContainerClass: 'terminbuchung-content',
            };
            this.step = null;

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
            this.formTemplate = {
                headline: (data) => `
                <p>Wir rufen Sie bei einem Telefon-Termin in dem von Ihnen ausgewählten Zeitraum an.</p>
                <p class="nomargin">Freie Termine für ${data.day}</p>
            `,
                timePeriod: (data, index) => `
                <input
                    class="form-check-input"
                    id="tp-${index}"
                    type="radio"
                    name="tx_akenzolfstermin_terminbuchung[buchung][timeperiod]"
                    value="${data.from}-${data.to}"
                    data-t="${data.fromts}"
                    data-e="${data.tots}"
                    data-p="${data.from}-${data.to}"
                    ${data.selected !== false && data.selected === data.fromts ? 'checked=checked' : ''}
                >
                <label for="kategorie-4" class="form-check-label">${data.from}-${data.to} Uhr</label>
            `,
                timeOccupied: (data, index) => `
                <label for="tp-${index}" class="form-check-label occupied">
                    ${data.from}-${data.to} (Dieser Zeitraum ist belegt.)
                </label>
            `,
            };
        }

        /**
         * initialize functions
         */
        init() {
            const akenzoTermin = document.querySelector(`div[class='${this.class.akenzoContainerClass}']`);
            if (akenzoTermin !== null && akenzoTermin !== undefined) {
                if (akenzoTermin.children.length > 0) {
                    this.dom = {
                        kalender: document.getElementById('lfskalender'),
                        kalenderundzeiten: document.getElementById('kalender-und-zeiten'),
                        terminliste: document.getElementById('terminliste'),
                        formular: document.getElementById('buchung'),
                        formHiddenFields: {
                            standort: document.querySelector("input[type='hidden'][name='tx_akenzolfstermin_terminbuchung[buchung][standort]']"),
                            kategorie: document.querySelector("input[type='hidden'][name='tx_akenzolfstermin_terminbuchung[buchung][kategorie]']"),
                            termin: document.querySelector("input[type='hidden'][name='tx_akenzolfstermin_terminbuchung[buchung][termin]']"),
                            provisionalToken: document.querySelector("input[type='hidden'][name='tx_akenzolfstermin_terminbuchung[buchung][provisionalToken]']"),
                            timeperiod: document.querySelector("input[type='hidden'][name='tx_akenzolfstermin_terminbuchung[buchung][timeperiod]']"),
                            daySelection: document.querySelector("input[type='hidden'][name='tx_akenzolfstermin_terminbuchung[daySelection]']"),
                            timeSeletion: document.querySelector("input[type='hidden'][name='tx_akenzolfstermin_terminbuchung[timeSeletion]']"),
                        },
                        formButtons: {
                            next: document.querySelector("button[name='tx_akenzolfstermin_terminbuchung[buchung-next]']"),
                        },
                    };
                    this.axajResponseHandler = {
                        updateKalender: (data) => {
                            const t = new XDate();
                            t.from(data.kalender.date).to('midnight first day of month');
                            data.date = t;
                            data.kalender = this.kalender.mergeCfg(data.kalender);
                            data.kalender.navigation.limitLeft = new XDate().to('first day of month midnight');
                            this.kalender.update(data.kalender);
                            this.dom.kalenderundzeiten.classList.remove('hidden');
                            if (this.kalender.cfg.selected
                                && this.kalender.getSelectedDays() !== null
                            ) {
                                this.kalender.getSelectedDays().dispatchEvent(new Event('click'));
                            }
                        },
                        tagAuswahl: (data) => {
                            const timeSelection = this.dom.formHiddenFields.timeSeletion.value;
                            // const termine = data.termine;
                            const firstTime = data.first;
                            const lastTime = data.last;
                            let t;
                            let d;

                            const xdate = new XDate('today midnight');
                            xdate.to(`+${firstTime} second`);

                            if (this.dom.terminliste.childNodes.length > 0) {
                                this.dom.terminliste.innerHTML = null;
                            }
                            if (firstTime !== undefined && lastTime !== undefined) {
                                for (t = firstTime; t < lastTime; t += (15 * 60)) {
                                    d = document.createElement('button');
                                    d.innerHTML = xdate.date('H:i');
                                    d.setAttribute('data-t', t);
                                    this.dom.terminliste.appendChild(d);
                                    if (Object.prototype.hasOwnProperty.call(data.termine, t)) {
                                        d.classList.add('frei');
                                        d.addEventListener('click', (evnt) => {
                                            evnt.preventDefault();
                                            evnt.stopPropagation();
                                            evnt.stopImmediatePropagation();
                                            const pEChildren = evnt.target.parentElement.children;
                                            const childs = Array.from(pEChildren);
                                            childs.forEach((child) => {
                                                child.classList.remove('selected');
                                            });
                                            evnt.target.classList.add('selected');
                                            const dt = evnt.target.dataset.t;
                                            evnt.target.dispatchEvent(this.kalender.selectEvent, dt);
                                        });
                                    } else {
                                        d.setAttribute('disabled', 'disabled');
                                        d.addEventListener('click', (evnt) => {
                                            evnt.preventDefault();
                                            evnt.stopPropagation();
                                            evnt.stopImmediatePropagation();
                                        });
                                    }
                                    xdate.to('+15 minute');
                                }
                                if (timeSelection !== '0') {
                                    this.dom.terminliste.querySelector(`button[data-t='${timeSelection}']`).dispatchEvent(new Event('click'));
                                }
                            } else if (data.type !== undefined
                                && data.type === 'TP'
                                && data.termine.length > 0
                            ) {
                                let r;
                                this.dom.terminliste.classList.add('no-flex');
                                const sDay = { day: data.selectedDay };
                                this.dom.terminliste.innerHTML += this.formTemplate.headline(sDay);
                                data.termine.forEach((date, index) => {
                                    const newDiv = document.createElement('div');
                                    newDiv.classList.add('time-period-select');
                                    this.dom.terminliste.appendChild(newDiv);
                                    if (date.occupied !== undefined && date.occupied === false) {
                                        newDiv.innerHTML = this.formTemplate.timePeriod(date, index);
                                        r = this.dom.terminliste.querySelector(`input[data-t='${date.fromts}']`);
                                        r.addEventListener('change', (evnt) => {
                                            evnt.preventDefault();
                                            evnt.stopPropagation();
                                            evnt.stopImmediatePropagation();
                                            const parentEl = evnt.target.parentElement.parentElement;
                                            const pEChildren = parentEl.querySelectorAll('input[id^=\'tp-\']');
                                            Array.from(pEChildren).forEach((child) => {
                                                child.classList.remove('selected');
                                            });
                                            evnt.target.classList.add('selected');
                                            const dt = evnt.target.dataset.t;
                                            this.dom.formHiddenFields.timeperiod.value = `${date.from}-${date.to}`;
                                            evnt.target.dispatchEvent(this.kalender.selectEvent, dt);
                                        });
                                    } else if (date.occupied === true) {
                                        newDiv.innerHTML = this.formTemplate.timeOccupied(date, index);
                                    }
                                });
                                if (timeSelection !== '0') {
                                    const selector = `input[data-t='${timeSelection}']`;
                                    const evntDispatcher = this.dom.terminliste.querySelector(selector);
                                    const eventReceiver = this.kalender.selectEvent;
                                    evntDispatcher.dispatchEvent(eventReceiver, timeSelection);
                                }
                            }
                            this.dom.terminliste.classList.remove('hidden');
                            this.dom.terminliste.dispatchEvent(new Event('updated'));
                        },
                        terminAuswahl: () => {
                            this.dom.formButtons.next.classList.remove('disabled');
                        },
                    };
                    this.initStep();
                    this.initEvents();
                }
            }
        }

        /* devGetQueryParams() {
            let params = {};
            if (document.location.toString().indexOf('?') !== -1) {
                let query = document.location
                    .toString()
                    .replace(/^.*?\?/, '')
                    .replace(/#.*$/, '')
                    .split('&');

                for (let i = 0, l = query.length; i < l; i++) {
                    let aux = decodeURIComponent(query[i]).split('=');
                    params[aux[0]] = aux[1];
                }
            }
            return params;
        } */

        requestKalenderUpdate(...args) {
            const date = (args.length) ? args[0] : this.kalender.getDate().getUnixtimestamp();

            this.query({
                q: 'updateKalender',
                standort: this.dom.formHiddenFields.standort.value,
                kategorie: this.dom.formHiddenFields.kategorie.value,
                date: date.toString(),
            });
        }

        initKalender() {
            const that = this;
            let termin = parseInt(this.dom.formHiddenFields.termin.value, 10);
            let daySelection = 0;
            const xd = new XDate();

            if (termin) {
                xd.setUnixtimestamp(termin);
                daySelection = xd.to('midnight').getUnixtimestamp();
                this.dom.formHiddenFields.daySelection.value = daySelection;
                this.dom.formHiddenFields.timeSeletion.value = termin - daySelection;

                termin = new XDate(termin).to('first day of month midnight').getUnixtimestamp();
            } else {
                termin = new XDate()
                    .to('first day of month midnight')
                    .getUnixtimestamp();
                this.dom.formHiddenFields.daySelection.value = 0;
                this.dom.formHiddenFields.timeSeletion.value = 0;
            }
            this.kalender = new Kalender(
                {
                    id: 'kalender',
                    locale: 'de',
                    parent: document.getElementById('kalender-container'),
                    date: termin,
                    selected: daySelection,
                    display: {
                        showWeekdays: true,
                    },
                    navigation: {
                        limitLeft: new XDate().to('first day of month midnight'),
                        limitRight: new XDate().to('first day of month midnight +3 month'),
                    },
                    events: {
                        onDaySelect: (evt, t) => {
                            that.dom.terminliste.classList.add('hidden');
                            that.dom.terminliste.innerHTML = null;
                            that.dom.formHiddenFields.daySelection.value = t;

                            that.query({
                                q: 'tagAuswahl',
                                tstamp: t,
                                standort: that.dom.formHiddenFields.standort.value,
                                kategorie: that.dom.formHiddenFields.kategorie.value,
                                provisionalToken: that.dom.formHiddenFields.provisionalToken.value,
                            });
                        },
                        onMonthChange: (evt, newDate) => {
                            that.dom.terminliste.classList.add('hidden');
                            that.requestKalenderUpdate(newDate);
                            that.dom.formHiddenFields.timeSeletion.value = 0;
                            that.dom.formHiddenFields.termin.value = 0;
                            that.dom.formButtons.next.classList.add('disabled');
                        },
                    },
                },
            );
            this.dom.kalenderundzeiten.classList.remove('hidden');
            this.requestKalenderUpdate();
        }

        initStep() {
            const that = this;
            const buchungNext = document.querySelector('input[type="hidden"][name*="[step]"]');
            let standorte = 0;
            let categories = 0;
            this.step = parseInt(buchungNext.value, 10);
            switch (this.step) {
            case 1:
                standorte = document.querySelectorAll("input[type='radio'][name='tx_akenzolfstermin_terminbuchung[buchung][standort]']");
                if (standorte.length > 0) {
                    standorte.forEach((standort) => {
                        if (standort.checked) {
                            that.dom.formButtons.next.classList.remove('disabled');
                        } else {
                            standort.addEventListener('change', () => {
                                that.dom.formButtons.next.classList.remove('disabled');
                            });
                        }
                    });
                }
                break;
            case 2:
                categories = document.querySelectorAll("input[type='radio'][name='tx_akenzolfstermin_terminbuchung[buchung][kategorie]']");
                if (categories.length > 0) {
                    categories.forEach((category) => {
                        if (category.checked) {
                            that.dom.formButtons.next.classList.remove('disabled');
                        } else {
                            category.addEventListener('change', () => {
                                that.dom.formButtons.next.classList.remove('disabled');
                            });
                        }
                    });
                }
                break;
            case 4:
                this.initKalender();
                break;
            default:
            }
        }

        onSubmit() {
            let standorte = 0;
            let kategories = 0;

            switch (this.step) {
            case 1:
                standorte = document.querySelectorAll("input[type='radio'][name='tx_akenzolfstermin_terminbuchung[buchung][standort]']");
                if (standorte.length > 0) {
                    standorte.forEach((standort) => {
                        if (standort.checked) {
                            return true;
                        }
                        return false;
                    });
                }
                break;
            case 2:
                kategories = document.querySelectorAll("input[type='radio'][name='tx_akenzolfstermin_terminbuchung[buchung][kategorie]']");
                if (kategories.length > 0) {
                    kategories.forEach((kategorie) => {
                        if (kategorie.checked) {
                            return true;
                        }
                        return false;
                    });
                }
                break;
            case 4:
                break;

            default:
            }

            return true;
        }

        initEvents() {
            const that = this;

            this.dom.formular.addEventListener('submit', (evnt) => that.onSubmit.call(that, evnt));

            if (this.step === 4) {
                const kalenderRoot = this.kalender.getRoot();
                kalenderRoot.addEventListener('initialized', () => {
                });
                kalenderRoot.addEventListener('updated', () => {
                });
                kalenderRoot.addEventListener('pleaseReload', () => {
                    that.requestKalenderUpdate();
                });

                this.dom.terminliste.addEventListener('select', (evt, time) => {
                    time = time === undefined ? evt.target.dataset.t : time;
                    that.query({
                        q: 'terminAuswahl',
                        standort: that.dom.formHiddenFields.standort.value,
                        kategorie: that.dom.formHiddenFields.kategorie.value,
                        termin: time,
                    });
                    that.dom.formHiddenFields.timeSeletion.value = time;
                    const parsedTime = parseInt(time, 10);
                    const daySelValue = that.dom.formHiddenFields.daySelection.value;
                    const parsedDaySelection = parseInt(daySelValue, 10);
                    const daySelection = parsedDaySelection + parsedTime;
                    that.dom.formHiddenFields.termin.value = daySelection;
                    if (evt.target.dataset.p !== undefined) {
                        that.dom.formHiddenFields.timeperiod.value = evt.target.dataset.p;
                    }
                });
            }

            if (this.step === 5) {
                // remove required from strnr if the user checks the no strn checkbox
                const keineStrnrCheckbox = document.getElementById('keinestrnr-cb');
                const strnrField = document.getElementById('step5-strnr');
                if (keineStrnrCheckbox && strnrField) {
                    // eslint-disable-next-line
                    keineStrnrCheckbox.addEventListener('change', function () {
                        if (this.checked) {
                            strnrField.removeAttribute('required');
                        } else {
                            strnrField.setAttribute('required', 'required');
                        }
                    });
                }

                // on step 5, send buttons with "btn-novalidate"
                document.querySelectorAll('.btn-novalidate').forEach((button) => {
                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        // remove focus from the clicked button
                        button.blur();

                        // only add hidden field if the button has name and value attributes
                        if (button.name && button.value) {
                            // create a hidden input with the same name and value as the button
                            const hiddenInput = document.createElement('input');
                            hiddenInput.type = 'hidden';
                            hiddenInput.name = button.name;
                            hiddenInput.value = button.value;

                            // append hidden input to the form
                            const form = document.getElementById('buchung');
                            form.appendChild(hiddenInput);

                            form.submit();

                            // cleanup
                            form.removeChild(hiddenInput);
                        } else {
                            // fallback, just submit
                            document.getElementById('buchung').submit();
                        }
                    });
                });
            }
        }

        query(data) {
            const that = this;
            const url = `${window.lfs_termin_request_url}/q/handleRequest${this.ajaxRequestSuffix}`;

            const dataJsonString = JSON.stringify(data);
            const cfg = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: dataJsonString,
            };
            if (window.location.hostname.indexOf('fin-rlp.de') < 0 && this.xhr[this.host] !== undefined && this.xhr[this.host].auth) {
                cfg.headers = { Authorization: `Basic ${btoa(this.xhr[this.host].auth)}` };
            }
            fetch(url, cfg)
                .then((response) => response.json())
                .then((result) => {
                    that.handleResponse(result, 'OK', null);
                });
        }

        handleResponse(data, status, xhr) {
            // if (data.hasOwnProperty('error'))
            if (Object.prototype.hasOwnProperty.call(data, 'error')) {
                /* eslint-disable no-console */
                console.error(data.error);
                /* eslint-enable no-console */
                return;
            }
            this.axajResponseHandler[data.ep].apply(this, [data.responseData, status, xhr, data]);
        }

        /*
        function init() {
            window.d = new XDate();
            window.b = new Buchung();
        }
        */
    }

    new Buchung();

    /*
    * PreprintedForms
     */
    class PreprintedForms {
        constructor() {
            this.class = {
                target: '.js-filter',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * initialize functions
         */
        init() {
            this.filter();
        }

        /**
         * Filter behavior.
         */
        filter() {
            if (document.querySelectorAll(this.class.target).length > 0) {
                // Event listener for filterPerson on change.
                document.getElementById('filterPerson').addEventListener('change', () => {
                    const filterPerson = document.getElementById('filterPerson');
                    const filterOccasion = document.getElementById('filterOccasion');
                    const filterYear = document.getElementById('filterYear');

                    if (filterPerson.value !== '0') {
                        filterOccasion.disabled = false;
                    } else {
                        filterOccasion.disabled = true;
                        filterYear.disabled = true;
                    }

                    if (filterOccasion.value !== '0') {
                        filterYear.disabled = false;
                    } else {
                        filterYear.disabled = true;
                    }
                });

                // Define the event listener for filterOccasion on change.
                document.getElementById('filterOccasion').addEventListener('change', () => {
                    const filterOccasion = document.getElementById('filterOccasion');
                    const filterYear = document.getElementById('filterYear');

                    if (filterOccasion.value !== '0') {
                        filterYear.disabled = false;
                    } else {
                        filterYear.disabled = true;
                    }
                });

                // Initial state.
                const setInitialState = () => {
                    const filterPerson = document.getElementById('filterPerson');
                    const filterOccasion = document.getElementById('filterOccasion');
                    const filterYear = document.getElementById('filterYear');

                    // Check the initial value of filterPerson
                    if (filterPerson.value === '0') {
                        // Set initial state when filterPerson is 0
                        filterOccasion.disabled = true;
                        filterYear.disabled = true;
                    } else {
                        // Set initial state when filterPerson is not 0
                        filterOccasion.disabled = false;

                        // Check the initial value of filterOccasion
                        if (filterOccasion.value === '0') {
                            filterYear.disabled = true;
                        } else {
                            filterYear.disabled = false;
                        }
                    }
                };
                setInitialState();
            }
        }
    }

    new PreprintedForms();

}));
